<template>
  <!-- 打印管理 -->
  <div class="print-management-container">
    <div class="content">
      <div class="operation">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item class="search-input" label="">
            <el-input v-model="keywords" placeholder="请输入模块名称" clearable></el-input>
          </el-form-item>
          <!-- 为啥我把这个按钮放在上面那个input后面会导致换行？ -->
          <el-form-item class="search-button" label="">
            <el-button @click="search">查询</el-button>
          </el-form-item>
          <el-form-item class="new-create" label="">
            <el-button type="primary" @click="dialogVisible = true">新建</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table :data="tableData" v-loading="loading" height='100%' width="100%">
          <el-table-column
            v-for="col in cols"
            :prop="col.id"
            :key="col.id"
            :label="col.name"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            label="操作"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="editRow(scope.row)">编辑</el-button>
              <el-button type="text" @click="deleteRow(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="val => pagination.pageSize = val"
        @current-change="val => pagination.currentPage = val"
        :current-page="pagination.currentPage"
        :page-size="pagination.pageSize"
        :page-sizes="pagination.pageSizes"
        layout="total, prev, pager, next"
        :total="pagination.total"
      ></el-pagination>
      <!-- 添加/编辑弹框 -->
      <el-dialog
        title="打印设置"
        :visible.sync="dialogVisible"
        width="800px"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="cancel"
        center
      >
        <div class="edit-content">
          <el-form :model="formData" :rules="rules" label-width="80px" label-position="left" ref="editForm">
            <el-form-item label="名称" prop="templateName">
              <el-input v-model="formData.templateName"></el-input>
            </el-form-item>
            <el-form-item label="上传模板">
              <el-upload
                class="upload-file"
                action="/system-api/printTemplate/uploadAndAnalysisFile"
                :on-success="uploadSuccess"
                :show-file-list="false"
                :before-upload="beforeUpload"
                :on-error="uploadError"
                :headers="headers"
                :data="{type: 'SYSTEM'}">
                <el-button class="upload-button" type="primary">上传</el-button>
                <span v-if="fileList.length > 0" class="file-name" slot="tip">
                  <span class="el-icon-document"></span>
                  <span @click.stop="uploadFile(fileList[0])">{{fileList[0].file}}</span>
                  <span class="el-icon-success"></span>
                  <span class="el-icon-close" @click.stop="removeFile"></span>
                </span>
              </el-upload>
            </el-form-item>
            <el-form-item label="系统数据" required>
              <el-col :span="11">
                <el-form-item prop="paramType">
                  <el-select v-model="formData.paramType" placeholder="请选择类型" filterable>
                    <el-option label="报表" value="报表"></el-option>
                    <el-option label="流程" value="流程"></el-option>
                    <el-option label="表单" value="表单"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="definitionId">
                  <el-select v-model="formData.definitionId" class="definitionId" placeholder="请选择数据表" filterable>
                    <el-option
                      v-for="item in dataReports"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="数据绑定"></el-form-item>
            <div v-if="dataList.length" class="list-content">
              <el-form-item v-for="(data, i) in dataList" :key="i" :label="`数据${i + 1}`">
                <!-- 根据模板加载出来的字段 -->
                <el-input :value="data" readonly></el-input>
                <!-- 所选报表/流程/表单控件 -->
                <el-select class="select-right" v-model="formData.templateFieldSettings[data]" placeholder="请选择" filterable>
                  <el-option
                    v-for="item in controls"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="save">保存</el-button>
          <el-button @click="cancel">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <transition name="el-fade-in-linear">
      <div class="modal-body" v-show="showHint">
        <div class="modal-content">
          <div class="title">您确认取消吗</div>
          <div class="operation">
            <el-button class="yes" @click="hintClick">是</el-button>
            <el-button class="no" @click="showHint = false">否</el-button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import tokenStorage from '@/plugins/tokenStorage'
import { UUID } from '@/plugins/common'
export default {
  name: 'printManagement',
  data () {
    return {
      loading: false,
      tableData: [],
      cols: [
        {id: 'templateName', name: '模块名称'},
        {id: 'paramType', name: '类型'},
        {id: 'definitionName', name: '数据名称'},
        {id: 'createTime', name: '创建时间'},
        {id: 'lastModifiedTime', name: '修改时间'}
      ],
      dialogVisible: false,
      keywords: '',
      formData: {
        templateName: '',
        paramType: '',
        definitionId: '',
        templateFieldSettings: {},
        // 模板解析出来的字段
        templateFields: [],
        definitionName: '',
        id: '',
        dataState: 'create'
      },
      fileList: [],
      dataReports: [],
      dataList: [],
      controls: [],
      pagination: {
        currentPage: 0,
        pageSize: 10,
        pageSizes: [10, 20, 30, 50, 100],
        total: 0
      },
      headers: {},
      rules: {
        templateName: [{ required: true, message: '请输入模板名称' }],
        paramType: [{ required: true, message: '请选择类型', trigger: 'change' }],
        definitionId: [{ required: true, message: '请选择数据表', trigger: 'change' }]
      },
      showHint: false
    }
  },
  methods: {
    async search () {
      this.loading = true
      let params = {
        index: this.pagination.currentPage,
        size: this.pagination.pageSize,
        filters: {
          templateName: this.keywords,
          paramType: '',
          definitionId: ''
        }
      }
      try {
        await this.$axios.get('/system-api/printTemplate', { params }).then(({data}) => {
          this.tableData = data.items
          this.pagination.total = data.total
        })
      } finally {
        this.loading = false
      }
    },
    editRow (row) {
      let data = {...row}
      data.templateFieldSettings = JSON.parse(data.templateFieldSettings)
      data.templateFields = JSON.parse(data.templateFields)
      this.dataList = data.templateFields
      this.fileList = [{file: data.fileName, dir: data.filePath}]
      this.formData = {...data}
      this.formData.dataState = 'update'
      this.dialogVisible = true
    },
    deleteRow (row) {
      this.$confirm('', '是否删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'deleMessageBox',
        center: true
      }).then(res => {
        this.$axios.delete(`/system-api/printTemplate/${row.id}`).then(res => this.search())
      }).catch(() => {})
    },
    beforeUpload (file) {
      let type = file.name.split('.').pop()
      if (['doc', 'docx'].indexOf(type) === -1) {
        this.$message.error('只能上传doc、docx文件')
        return false
      }
    },
    // 点击下载文件
    uploadFile (file) {
      let downloadUrl = this.getDownLoadUrl(file.dir)
      window.open(`${downloadUrl}${this.fileList[0].dir}`)
    },
    // 上传完成，获取解析字段
    uploadSuccess (res, file, fileList) {
      let list = res.result.elementsWord || []
      this.fileList = [{dir: res.result.dir, file: res.result.file}]
      this.formData.templateName = res.result.file
      this.dataList = [...list]
      // 如果新的模板包含旧的模板字段，不需要删除
      let data = {}
      if (Object.keys(this.formData.templateFieldSettings).length > 0 && list && list.length > 0) {
        for (let key in this.formData.templateFieldSettings) {
          if (list.includes(key)) {
            data[key] = this.formData.templateFieldSettings[key]
          }
        }
      }
      this.formData.templateFieldSettings = {...data}
    },
    uploadError (res) {
      if (res.message) {
        this.$message.error(JSON.parse(res.message).message)
      }
    },
    cancel () {
      this.showHint = true
    },
    hintClick () {
      this.showHint = false
      this.dialogVisible = false
    },
    save () {
      this.$refs.editForm.validate(v => {
        if (v) {
          if (this.fileList.length === 0) {
            this.$message.error('请先上传模板')
            return false
          }
          let url = ''
          let params = {
            templateName: this.formData.templateName,
            templateFields: JSON.stringify(this.dataList),
            templateFieldSettings: JSON.stringify(this.formData.templateFieldSettings),
            paramType: this.formData.paramType,
            definitionId: this.formData.definitionId,
            fileName: this.fileList[0].file,
            filePath: this.fileList[0].dir,
            definitionName: this.formData.definitionName
          }
          if (this.formData.dataState === 'update') {
            params.id = this.formData.id
            url = '/system-api/printTemplate/update'
          } else {
            params.id = UUID.create()
            url = '/system-api/printTemplate'
          }
          this.$axios.post(url, params).then(res => {
            this.dialogVisible = false
          })
        } else {
          return false
        }
      })
    },
    getList (type) {
      if (type) {
        let url = ''
        if (type === '报表') {
          url = '/report-api/report/definition/reports'
        } else if (type === '表单') {
          url = '/form-api/defines'
        } else if (type === '流程') {
          url = '/process-api/processes/findAll'
        }
        this.$axios.get(url).then(res => {
          this.dataReports = res.data || []
        })
      }
    },
    // 获取报表的所有控件
    getReportControl (id) {
      this.controls = []
      this.$axios.get(`/report-api/report/definition/${id}?type=edit`).then(({data}) => {
        data.columns && data.columns.length && data.columns.forEach(control => {
          this.controls.push({id: control.id, name: control.name})
        })
      })
    },
    // 获取表单的所有控件
    getFormControl (id) {
      this.controls = []
      this.$axios.get(`/form-api/defines/${id}`).then(({data}) => {
        // 如果relations有值，则使用relations中的第一个的primaryTable为主表id
        let schema = data.form.schema
        let id = schema.relations.length !== 0 ? schema.relations[0].primaryTable : schema.tables[0].id
        this.publicGetFormControl(schema.tables.find(t => t.id === id).columns)
      })
    },
    // 获取流程的所有控件
    getProcesstControl (id) {
      this.controls = []
      this.$axios.get(`/process-api/processes/${id}?isEdit=true`).then(({data}) => {
        // 如果relations有值，则使用relations中的第一个的primaryTable为主表id
        let schema = data.schema
        let id = schema.relations.length !== 0 ? schema.relations[0].primaryTable : schema.tables[0].id
        this.publicGetFormControl(schema.tables.find(t => t.id === id).columns)
      })
    },
    // 流程和表单获取控件方式一样
    publicGetFormControl (array) {
      array.length && array.forEach(control => this.controls.push({id: control.id, name: control.name}))
    },
    getDownLoadUrl (path) {
      return path.includes('USER') ? sessionStorage.getItem('ossDownloadUrl') : sessionStorage.getItem('ossDownloadUrl')
    },
    clearFormData () {
      this.formData = {
        templateName: '',
        paramType: '',
        definitionId: '',
        templateFieldSettings: {},
        // 模板解析出来的字段
        templateFields: [],
        definitionName: '',
        id: '',
        dataState: 'create'
      }
      this.fileList = []
      this.dataList = []
      this.dataReports = []
      this.controls = []
      this.$nextTick(() => this.$refs.editForm.clearValidate(['templateName', 'paramType', 'definitionId']))
    },
    removeFile () {
      this.formData.templateFieldSettings = {}
      this.formData.templateFields = []
      this.dataList = []
      this.fileList = []
    }
  },
  watch: {
    'formData.definitionId' (val, odlVal) {
      if (val) {
        if (this.dataReports.length) {
          this.formData.definitionName = this.dataReports.find(e => e.id === val).name
        }
        if (this.formData.paramType === '表单') {
          this.getFormControl(val)
        } else if (this.formData.paramType === '流程') {
          this.getProcesstControl(val)
        } else if (this.formData.paramType === '报表') {
          this.getReportControl(val)
        }
        if (odlVal !== '') {
          this.controls = []
          this.formData.templateFieldSettings = {}
        }
      }
    },
    dialogVisible (val) {
      if (!val) {
        // 需要清空弹框内容
        this.clearFormData()
        this.search()
      }
    },
    'formData.paramType' (val, odlVal) {
      this.getList(val)
      // 防止编辑的时候清空
      if (odlVal !== '' && this.formData.definitionId !== '') {
        this.formData.definitionId = ''
        this.formData.templateFieldSettings = {}
        this.controls = []
      }
    },
    'pagination.currentPage' (val) { this.search() },
    'pagination.pageSize' (val) { this.search() }
  },
  created () {
    this.search()
    this.headers = {
      Authorization: tokenStorage.getToken()
    }
  }
}
</script>

<style lang="scss">
  .print-management-container {
    height: 100%;
    padding: 10px 20px;
    background-color: #fff;
    position: relative;

    & > .content {
      height: 100%;

      .el-form {
        .search-input {
          .el-input {
            .el-input__inner {
              width: 248px;
              height: 24px;
              background: #FEFEFE;
              border: 1px solid #C2C3C4;
              border-radius: 4px;
            }
          }
        }
        .search-button {
          .el-button {
            width:40px;
            height:24px;
            border: 1px solid #55ACF1;
            color: #55ACF1;
            padding: 0;
            border-radius:4px;
            margin-left: 8px;

            &:hover,&:active,&:focus {
              background-color: #fff;
            }
          }
        }

        .new-create {
          float: right;

          .el-button {
            width:40px;
            height:24px;
            padding: 0;
            border-radius: 4px;
            margin-left: 18px;
          }
        }
      }
      .table {
        height: calc(100% - 80px);
      }

      .el-dialog__body {
        padding: 25px 0 0 50px;
        max-height: 600px;

        .edit-content {
          .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
            display: none;
          }
          .list-content {
            max-height: 322px;
            overflow: auto;
          }
          .el-form {
            .el-form-item {
              .el-form-item__content {
                .upload-button {
                  width:40px;
                  height:24px;
                  padding: 0;
                  border-radius: 4px;
                }
                .el-input {
                  width: 300px;
                  height: 28px;

                  .el-input__inner {
                    width: 300px;
                    height: 28px;
                    border: 1px solid #C2C3C4;
                    border-radius: 4px;
                  }
                }

                .file-name {
                  margin-left: 32px;
                  cursor: pointer;

                  .el-icon-close {
                    display: none;
                    margin-left: 28px;
                  }

                  &:hover {
                    .el-icon-close {
                      display: inline-block;
                    }
                    .el-icon-success {
                      display: none;
                    }
                  }

                  .el-icon-document {
                    margin-right: 5px;
                  }
                  .el-icon-success {
                    color: #57C661;
                    margin-left: 28px;
                  }
                }

                .select-right {
                  margin-left: 12px;
                }

                .definitionId {
                  margin-left: 8px;
                }

                .el-col {
                  .el-form-item {
                    margin-bottom: 0;
                  }
                }
              }
            }
          }
        }
      }

      .dialog-footer {
        .el-button+.el-button {
          margin-left: 50px;
          border: 1px solid #54ABF1;
          color: #54ABF1;

          &:hover,&:active,&:focus {
            background-color: #fff;
          }
        }
        .el-button {
          width:82px;
          height:26px;
          padding: 0;
          line-height: 26px;
          border-radius: 4px;
        }
      }

      .el-pagination {
        text-align: right;
        padding-top: 10px;
      }
    }

    & > .modal-body {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 9999;
      background-color: transparent;
      top: 0;
      left: 0;

      & > .modal-content {
        position: absolute;
        width: 340px;
        height: 122px;
        background-color: rgba(0, 0, 0, .7);
        border: none;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        border-radius: 6px;
        left: calc(50% - 240px);
        top: calc(50% - 140px);

        .title {
          color: #fff;
          text-align: center;
          padding: 30px 0 35px 0;
          font-size: 12px;
        }

        .operation {
          text-align: center;

          .el-button {
            width:82px;
            height:26px;
            padding: 0;
          }

          .no {
            background-color: #3a8ee6;
            border-color: #3a8ee6;
            margin-left: 50px;

            &:hover {
              background-color: #3a8ee6;
              border-color: #3a8ee6;
            }

            span {
              color: #fff;
            }
          }

          .yes {
            background-color: transparent;
            border-color: #54abf2;

            span {
              color: #54abf2;
            }

            &:hover {
              color: #54abf2;
              border-color: #54abf2;
              background-color: transparent;
            }

            &:active {
              border-color: #54abf2;
              background-color: transparent;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/users/print-management.vue